'use client';

import React from 'react';
import clsx from 'clsx';

interface CarouselDotButtonPropType {
    onClick: () => void;
    isActive: boolean;
}

export const CarouselDotButton: React.FC<CarouselDotButtonPropType> = (props) => {
    const { onClick, isActive } = props;

    return (
        <button
            className={clsx(
                'carousel__dot-button',
                isActive && 'carousel__dot-button--active'
            )}
            onClick={onClick}
        />
    );
};
